<template>
    <fieldset>
        <p>OBS! Det är ej lämpligt att koppla fler än en integration av denna typ till en profil.</p>

        <template v-if="oauthDone">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Access Token</div>
                </div>
                <textarea type="text" class="form-control" required v-model="accessToken" @input="onUpdate" rows="5">

        </textarea>
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Refresh Token</div>
                </div>
                <input type="text" class="form-control" required v-model="refreshToken" @input="onUpdate">
            </div>

            <div class="mb-3">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text">Skapa kunder från visitkort</div>
                    </div>
                    <select class="custom-select" v-model="useCreateCustomers" @change="onUpdate" required>
                        <option :value="false">Nej</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>
            </div>
            <div class="mb-3">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text">Skapa pdf-erbjudanden från Fortnox</div>
                    </div>
                    <select class="custom-select" v-model="usePdfOffers" @change="onUpdate" required>
                        <option :value="false">Nej</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Fältnamn: Gatuadress </div>
                </div>
                <input type="text" class="form-control" required v-model="fieldDeliveryStreetAddress" @input="onUpdate">
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Fältnamn: Postnummer</div>
                </div>
                <input type="text" class="form-control" required v-model="fieldDeliveryZipCode" @input="onUpdate">
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Fältnamn: Ort</div>
                </div>
                <input type="text" class="form-control" required v-model="fieldDeliveryCity" @input="onUpdate">
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Fältnamn: Land</div>
                </div>
                <input type="text" class="form-control" required v-model="fieldDeliveryCountry" @input="onUpdate">
            </div>
        </template>

        <oauth-auth-code-workflow v-else :initiator="route('integrations.fortnox.auth.initiate')"
                                  @success="handleOauthSuccess" @failure="handleOauthFailure"/>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import OauthAuthCodeWorkflow from "../oauth-auth-code-workflow.vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const accessToken = ref(null);
const refreshToken = ref(null);
const lastUpdated = ref(null);
const useCreateCustomers = ref(false);
const useOffers = ref(false);
const usePdfOffers = ref(false);
const useMarkOfferAsSent = ref(false);
const fieldDeliveryStreetAddress = ref(null);
const fieldDeliveryZipCode = ref(null);
const fieldDeliveryCity = ref(null);
const fieldDeliveryCountry = ref(null);
const oauthDone = computed(() => {
  return accessToken.value && refreshToken.value;
});
const serializedValue = computed(() => {
  return {
    access_token: accessToken.value,
    refresh_token: refreshToken.value,
    last_updated: lastUpdated.value,
    use_create_customers: useCreateCustomers.value,
    use_offers: useOffers.value,
    use_pdf_offers: usePdfOffers.value,
    use_mark_offer_as_sent: useMarkOfferAsSent.value,
    field_delivery_street_address: fieldDeliveryStreetAddress.value,
    field_delivery_zip_code: fieldDeliveryZipCode.value,
    field_delivery_city: fieldDeliveryCity.value,
    field_delivery_country: fieldDeliveryCountry.value
  };
});
function handleOauthSuccess([newAccessToken, newRefreshToken]) {
  accessToken.value = newAccessToken;
  refreshToken.value = newRefreshToken;
  lastUpdated.value = new Date().toISOString().slice(0, 19).replace('T', ' ');
  onUpdate();
}
function handleOauthFailure(error) {
  console.log(error);
}
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    accessToken.value = modelValue.value.access_token;
    refreshToken.value = modelValue.value.refresh_token;
    lastUpdated.value = modelValue.value.last_updated;
    useCreateCustomers.value = modelValue.value.use_create_customers;
    useOffers.value = modelValue.value.use_offers;
    usePdfOffers.value = modelValue.value.use_pdf_offers;
    useMarkOfferAsSent.value = modelValue.value.use_mark_offer_as_sent;
    fieldDeliveryStreetAddress.value = modelValue.value.field_delivery_street_address;
    fieldDeliveryZipCode.value = modelValue.value.field_delivery_zip_code;
    fieldDeliveryCity.value = modelValue.value.field_delivery_city;
    fieldDeliveryCountry.value = modelValue.value.field_delivery_country;
    if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
      onUpdate();
    }
  }
}, {
  immediate: true
});
watch(() => props.defaultMode, () => {
  // Using this because of @input was faster than v-model on checkbox
  emit("update:modelValue", serializedValue.value);
});
</script>
